import { Controller } from "stimulus"
export default class extends Controller {

 static get targets() {
   return ['submit'];
  }

  initialize(){
  }

  callback(token) {
   let t = this;
   return new Promise(function(resolve, reject) {
     t.element.submit(); 
   })
  }

  connect() {
    let t = this;
    setTimeout(function() {
    grecaptcha.render(t.submitTarget, {
      sitekey: '6LcwN84ZAAAAAAd3XjNd40-Lp4trHYaKAuN3gH5u', 
      callback: t.callback.bind(t)  
    })
    },  500);
  }

}
